import { useEffect } from "react"
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { useAuthContext } from "../../contexts/AuthContext";
import { BrandLogo } from "../../assets/brandLogo/_index";
import { notification } from "antd";

const USERNAME_ID = 'username';
const PASSWORD_ID = 'password';

const BottomBorder = styled.div`
    position: relative;
    bottom: 0;
    background-color: transparent;
    border-bottom: 5px solid #86BC25;
    margin-top: auto;
`;

const Input = styled.input`
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
`;

const SummitButton = styled.button`
    width: 100%;
    background-color: #86bc25;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
`;

export function LoginScreen() {
    const { register, handleSubmit, watch, trigger, formState: { isValid } } = useForm({
        mode: 'onTouched',
        defaultValues: {
            [USERNAME_ID]: '',
            [PASSWORD_ID]: '',
        }
    })
    const { login, isLogging, isError } = useAuthContext();

    // Trigger validation when user starts to write password
    const watchPwd = watch(PASSWORD_ID);
    useEffect(() => {
        if (watchPwd) {
            trigger([USERNAME_ID, PASSWORD_ID]);
        }
    }, [trigger, watchPwd]);

    const handleLogin = (e) =>{//temporary
        if(e.username === 'Cascais_user1' && e.password === 'D3l0itt3'){
            login(e.username, e.password);
        } else {
            notification.error({
                  message: 'Login unauthorized',
                  description:
                    'User or passowrd incorrect',
                //   onClick: () => {
                //     console.log('Notification Clicked!');
                //   },
            });
        }
    }

    return(
        <div style={{position:"relative", zIndex:"0", minHeight:'100vh', display:'flex', flexDirection:'column', backgroundColor: '#e5e5e5', justifyContent: 'center'}}>
            <div style={{alignSelf: 'center', position: 'absolute'}}>
                <div style={{backgroundColor: '#FFFFFF', padding: '30px 30px 20px', borderRadius: '2px'}}>
                    <div style={{padding:"40px 24px 24px 24px"}}>
                        <BrandLogo width={350} height={125} />
                    </div>

                    <form onSubmit={handleSubmit((data) => handleLogin(data))}>
                        <div style={{marginBottom: '2rem'}}>
                            <p style={{marginBottom: 0}}>Username</p>
                            <Input placeholder='Username' name="username" {...register("username")}/>
                        </div>

                        <div style={{marginBottom: '2rem'}}>
                            <p style={{marginBottom: 0}}>Password</p>
                            <Input type='password' placeholder='Password' name="password" {...register("password")}/>
                        </div>

                        {/* SUBMIT */}
                        <div style={{display:"flex", justifyContent:"center"}}>
                            <SummitButton type="submit">
                                Sign In
                            </SummitButton>
                        </div>
                    </form>
                </div>
            </div>

            <BottomBorder as="footer" id="main-footer">
                <div>
                    <div style={{padding:"48px 0px 24px 60px"}}>
                        <BrandLogo width={100} height={35} />
                    </div>
                </div>
            </BottomBorder>
        </div>
    )
}